import { labeled, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      reducedRepayments: Joi.boolean(),
      lowerInterestRate: Joi.boolean(),
      increaseTotalLoanAmount: Joi.boolean(),
      greaterFlexibility: Joi.boolean(),
      reduceNumberOfLenders: Joi.boolean(),
      dissatisfiedWithOtherFinancialInstitution: Joi.boolean(),
      closeToEndOfCurrentLoanTerm: Joi.boolean(),
      other: Joi.boolean()
    })
    .label(labeled(label, 'Refinance and debt consolidation'))
    .when('..purposeDetails.refinance', {
      is: true,
      then: custom(Joi)
        .object()
        .keys({
          reducedRepayments: Joi.boolean(),
          lowerInterestRate: Joi.boolean(),
          increaseTotalLoanAmount: Joi.boolean(),
          greaterFlexibility: Joi.boolean(),
          reduceNumberOfLenders: Joi.boolean(),
          dissatisfiedWithOtherFinancialInstitution: Joi.boolean(),
          closeToEndOfCurrentLoanTerm: Joi.boolean(),
          other: Joi.boolean()
        })
        .orValue(
          'reducedRepayments',
          'lowerInterestRate',
          'increaseTotalLoanAmount',
          'greaterFlexibility',
          'reduceNumberOfLenders',
          'dissatisfiedWithOtherFinancialInstitution',
          'closeToEndOfCurrentLoanTerm',
          'other'
        )
        .label(labeled(label, 'Why does the applicant(s) want to refinance the existing loan?'))
        .when('.reducedRepayments', {
          is: true,
          then: Joi.object().keys({
            reducedRepaymentsComments: Joi.string()
              .required()
              .label(labeled(label, 'Reduced Repayments Comments'))
          })
        })
        .when('.lowerInterestRate', {
          is: true,
          then: Joi.object().keys({
            lowerInterestRateComments: Joi.string()
              .required()
              .label(labeled(label, 'Lower Interest Rate Comments'))
          })
        })
        .when('.greaterFlexibility', {
          is: true,
          then: Joi.object().keys({
            greaterFlexibilityComments: Joi.string()
              .required()
              .label(labeled(label, 'Greater Flexibility Comments'))
          })
        })
        .when('.reduceNumberOfLenders', {
          is: true,
          then: Joi.object().keys({
            reduceNumberOfLendersComments: Joi.string()
              .required()
              .label(labeled(label, 'Reduce Number Of Lenders Comments'))
          })
        })
        .when('.dissatisfiedWithOtherFinancialInstitution', {
          is: true,
          then: Joi.object().keys({
            dissatisfiedWithOtherFinancialInstitutionComments: Joi.string()
              .required()
              .label(labeled(label, 'Dissatisfied With Other Financial Institution Comments'))
          })
        })
    })
    .when('..purposeDetails.debtConsolidation', {
      is: true,
      then: custom(Joi)
        .object()
        .keys({
          reducedRepayments: Joi.boolean(),
          lowerInterestRate: Joi.boolean(),
          increaseTotalLoanAmount: Joi.boolean(),
          greaterFlexibility: Joi.boolean(),
          reduceNumberOfLenders: Joi.boolean(),
          dissatisfiedWithOtherFinancialInstitution: Joi.boolean(),
          closeToEndOfCurrentLoanTerm: Joi.boolean(),
          other: Joi.boolean()
        })
        .orValue(
          'reducedRepayments',
          'lowerInterestRate',
          'increaseTotalLoanAmount',
          'greaterFlexibility',
          'reduceNumberOfLenders',
          'dissatisfiedWithOtherFinancialInstitution',
          'closeToEndOfCurrentLoanTerm',
          'other'
        )
        .label(labeled(label, 'Why does the applicant(s) want to refinance the existing loan?'))
        .when('.reducedRepayments', {
          is: true,
          then: Joi.object().keys({
            reducedRepaymentsComments: Joi.string()
              .required()
              .label(labeled(label, 'Reduced Repayments Comments'))
          })
        })
        .when('.lowerInterestRate', {
          is: true,
          then: Joi.object().keys({
            lowerInterestRateComments: Joi.string()
              .required()
              .label(labeled(label, 'Lower Interest Rate Comments'))
          })
        })
        .when('.greaterFlexibility', {
          is: true,
          then: Joi.object().keys({
            greaterFlexibilityComments: Joi.string()
              .required()
              .label(labeled(label, 'Greater Flexibility Comments'))
          })
        })
        .when('.reduceNumberOfLenders', {
          is: true,
          then: Joi.object().keys({
            reduceNumberOfLendersComments: Joi.string()
              .required()
              .label(labeled(label, 'Reduce Number Of Lenders Comments'))
          })
        })
        .when('.dissatisfiedWithOtherFinancialInstitution', {
          is: true,
          then: Joi.object().keys({
            dissatisfiedWithOtherFinancialInstitutionComments: Joi.string()
              .required()
              .label(labeled(label, 'Dissatisfied With Other Financial Institution Comments'))
          })
        })
    })
    .label(labeled(label, 'Purpose'));

export default {
  schema
};
